import { atom } from 'recoil';

// Unread insight counts powering the sidebar badge.
// Written by the Sidebar (initial fetch) and the Insights page (on changes).
export const insightsCountAtom = atom({
  key: 'insightsCount',
  default: { active: 0, critical: 0 },
});
